import React, { useState, useEffect, useRef } from 'react'
import {
  getRequest,
  getStandardDate,
  postRequest
} from '../../globalhelper/helper'
import DataTable from '../../components/DataTable2'
import GetAppIcon from '@material-ui/icons/GetApp'
import { CSVLink } from 'react-csv'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TableWithDownload from '../../components/TableWithDownload'
import Popup from '../../components/SimplePOPUP'
import _ from 'lodash'
import { HiOutlineRefresh } from 'react-icons/hi'
import { Animated } from 'react-animated-css'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TableContainer,
  TableHead,
  TextField,
  Tooltip
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import DialougeBox from '../VR2_Form_Rendering/DialougeBox'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import store from '../../store'
import { hideLoader, showLoader } from '../../redux/Common/commonActions'

export const FunctionalJournal = (props) => {
  const [state, setState] = useState({
    showActivate: true,
    Companies: [],
    Company: '',
    EditTable: {
      data: null,
      columns: [
        {
          name: 'BaseValue',
          selector: 'BaseValue'
        },
        {
          name: 'DocumentNumber',
          selector: 'documentnumber'
        },
        {
          name: 'TotalBaseValue',
          selector: 'TotalBaseValue'
        },
        {
          name: 'AmortizedValue',
          selector: 'AmortizedValue'
        },
        {
          name: 'BalanceToBeAmortized',
          selector: 'amountinlocalcurrency'
        },
        {
          name: 'SenderName',
          selector: 'sendername'
        },
        {
          name: 'ItemName',
          selector: 'itemname'
        },
        {
          name: 'DocumentRef',
          selector: 'documentref'
        },
        {
          name: 'DocumentDate',
          selector: 'documentdate'
        }
      ]
    },
    _Table_1: {
      data: null,
      FULL_data: null,
      selected_ID: [],
      columns: [
        {
          name: 'Document Number',
          selector: 'documentnumber'
        },
        {
          name: 'DocumentType',
          selector: 'documenttype'
        },
        {
          name: 'Vendor Name',
          selector: 'sendername'
        },
        {
          name: 'Invoice Number',
          selector: 'documentref'
        },
        {
          name: 'Current BaseValue',
          selector: 'basevalueforthismonth'
        },
        {
          name: 'AJ Posted',
          selector: 'processedajforthismonth'
        },
        {
          name: 'AJ ToPost',
          selector: 'topostaj'
        },
        {
          name: 'Total BaseValue of the Bill',
          selector: 'basevalueforthisbill'
        },
        {
          name: 'Total Amortised AJ for the Bill',
          selector: 'processedajforthisbill'
        },
        {
          name: 'Balance AJ to be Amortised',
          selector: 'balanceaj'
        },
        {
          name: 'SumOf PostJournal',
          selector: 'sumofpostjournal'
        },
        {
          name: 'SumOf AllocationValue',
          selector: 'sumofallocationvalue'
        },
        {
          name: 'Month',
          selector: 'month'
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom'
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto'
        },
        {
          name: 'CA Posted',
          selector: 'processedcaforthismonth'
        },
        {
          name: 'CA ToPost',
          selector: 'topostca'
        },
        {
          name: 'Total Amortised CA for the Bill',
          selector: 'processedcaforthisbill'
        },
        {
          name: 'Balance CA to be Amortised',
          selector: 'balanceca'
        }
      ]
    },
    _Table_2: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'BillNumber',
          selector: 'documentnumber',
          style: { minWidth: '120px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountDate',
          selector: 'accountingdate',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountClass',
          selector: 'accountclass',
          style: { minWidth: '170px' }
        },
        {
          name: 'MISGrouping',
          selector: 'misgrouping',
          style: { minWidth: '170px' }
        },
        {
          name: 'AccountType',
          selector: 'accounttype',
          style: { minWidth: '100px' }
        },
        {
          name: 'LedgerName',
          selector: 'ledgername',
          style: { minWidth: '170px' }
        },
        {
          name: 'AccountGroup',
          selector: 'accountgroup',
          style: { minWidth: '170px' }
        },
        {
          name: 'AccountCode',
          selector: 'accountcode',
          style: { minWidth: '100px' }
        },
        {
          name: 'ItemType',
          selector: 'itemtype',
          style: { minWidth: '70px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom',
          style: { minWidth: '100px' }
        },
        {
          name: 'InvoiceRef',
          selector: 'documentref',
          style: { minWidth: '110px' }
        },
        {
          name: 'AmtInLclCurr',
          selector: 'amountinlocalcurrency',
          style: { minWidth: '70px' }
        },
        {
          name: 'AmtInTxnCurr',
          selector: 'amountintransactioncurrency',
          style: { minWidth: '70px' }
        }
      ]
    },
    _Table_3: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'BillNumber',
          selector: 'documentnumber',
          style: { minWidth: '120px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        },
        {
          name: 'CostAllocationMethod',
          selector: 'costallocationmethod',
          style: { minWidth: '190px' }
        },
        {
          name: 'LOB',
          selector: 'lob',
          style: { minWidth: '60px' }
        },
        {
          name: 'CostAllocationParameterValue',
          selector: 'costallocationparametervalue',
          style: { minWidth: '100px' }
        },
        {
          name: 'CostAllocated Lcl Curr',
          selector: 'amountinlocalcurrency',
          style: { minWidth: '100px' }
        }
      ]
    },
    Table1: {
      data: null,
      FULL_data: null,
      selected_ID: [],
      columns: [
        {
          name: 'Document Number',
          selector: 'documentnumber'
        },
        {
          name: 'DocumentType',
          selector: 'documenttype'
        },
        {
          name: 'Vendor Name',
          selector: 'sendername'
        },
        {
          name: 'Invoice Number',
          selector: 'documentref'
        },
        {
          name: 'This Month BaseValue',
          selector: 'basevalueforthismonth'
        },
        {
          name: 'This Month AJ Posted',
          selector: 'processedajforthismonth'
        },
        {
          name: 'This Month AJ ToPost',
          selector: 'topostaj'
        },
        {
          name: 'This Month CA Posted',
          selector: 'processedcaforthismonth'
        },
        {
          name: 'This Month CA ToPost',
          selector: 'topostca'
        },
        {
          name: 'Total BaseValue of the Bill',
          selector: 'basevalueforthisbill'
        },
        {
          name: 'Total Amortised AJ for the Bill',
          selector: 'processedajforthisbill'
        },
        {
          name: 'Balance AJ to be Amortised',
          selector: 'balanceaj'
        },
        {
          name: 'Total Amortised CA for the Bill',
          selector: 'processedcaforthisbill'
        },
        {
          name: 'Balance CA to be Amortised',
          selector: 'balanceca'
        },
        {
          name: 'SumOf PostJournal',
          selector: 'sumofpostjournal'
        },
        {
          name: 'SumOf AllocationValue',
          selector: 'sumofallocationvalue'
        },
        {
          name: 'Month',
          selector: 'month'
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom'
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto'
        }
      ]
    },
    Table2: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'BillNumber',
          selector: 'documentnumber',
          style: { minWidth: '120px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountDate',
          selector: 'accountingdate',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountClass',
          selector: 'accountclass',
          style: { minWidth: '170px' }
        },
        {
          name: 'MISGrouping',
          selector: 'misgrouping',
          style: { minWidth: '170px' }
        },
        {
          name: 'AccountType',
          selector: 'accounttype',
          style: { minWidth: '100px' }
        },
        {
          name: 'LedgerName',
          selector: 'ledgername',
          style: { minWidth: '170px' }
        },
        {
          name: 'AccountGroup',
          selector: 'accountgroup',
          style: { minWidth: '170px' }
        },
        {
          name: 'AccountCode',
          selector: 'accountcode',
          style: { minWidth: '100px' }
        },
        {
          name: 'ItemType',
          selector: 'itemtype',
          style: { minWidth: '70px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom',
          style: { minWidth: '100px' }
        },
        {
          name: 'InvoiceRef',
          selector: 'documentref',
          style: { minWidth: '110px' }
        },
        {
          name: 'AmtInLclCurr',
          selector: 'amountinlocalcurrency',
          style: { minWidth: '70px' }
        },
        {
          name: 'AmtInTxnCurr',
          selector: 'amountintransactioncurrency',
          style: { minWidth: '70px' }
        }
      ]
    },
    Table3: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'BillNumber',
          selector: 'documentnumber',
          style: { minWidth: '120px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        },
        {
          name: 'CostAllocationMethod',
          selector: 'costallocationmethod',
          style: { minWidth: '190px' }
        },
        {
          name: 'LOB',
          selector: 'lob',
          style: { minWidth: '60px' }
        },
        {
          name: 'CostAllocationParameterValue',
          selector: 'costallocationparametervalue',
          style: { minWidth: '100px' }
        },
        {
          name: 'CostAllocated Lcl Curr',
          selector: 'amountinlocalcurrency',
          style: { minWidth: '100px' }
        }
      ]
    },
    Table_1: {
      data: null,
      FULL_data: null,
      selected_ID: [],
      columns: [
        {
          name: 'DocumentNumber',
          selector: 'documentnumber'
        },
        {
          name: 'DocumentType',
          selector: 'documenttype'
        },
        {
          name: 'VenderName',
          selector: 'sendername'
        },
        {
          name: 'TotalBaseValue',
          selector: 'totalbasevalue'
        },
        {
          name: 'ThisPrdBaseValue',
          selector: 'thisprdbasevalue'
        },
        {
          name: 'BillValue',
          selector: 'billvalue'
        },
        {
          name: 'ProcessedAJ',
          selector: 'processedaj'
        },
        {
          name: 'ToPostAJ',
          selector: 'topostaj'
        },
        {
          name: 'SumOfPostJournal',
          selector: 'sumofpostjournal'
        },
        {
          name: 'ProcessedCA',
          selector: 'processedca'
        },
        {
          name: 'ToPostCA',
          selector: 'topostca'
        },
        {
          name: 'SumOfAllocationValue',
          selector: 'sumofallocationvalue'
        },
        {
          name: 'Month',
          selector: 'month'
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom'
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto'
        }
      ]
    },
    Table_2: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'DocumentNumber',
          selector: 'documentnumber',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountDate',
          selector: 'accountingdate',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountClass',
          selector: 'accountclass',
          style: { minWidth: '100px' }
        },
        {
          name: 'MISGrouping',
          selector: 'misgrouping',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountCode',
          selector: 'accountcode',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountType',
          selector: 'accounttype',
          style: { minWidth: '100px' }
        },
        {
          name: 'AmtInLclCurr',
          selector: 'amountinlocalcurrency',
          style: { minWidth: '100px' }
        },
        {
          name: 'LedgerName',
          selector: 'ledgername',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountGroup',
          selector: 'accountgroup',
          style: { minWidth: '100px' }
        },
        {
          name: 'ItemType',
          selector: 'itemtype',
          style: { minWidth: '100px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom',
          style: { minWidth: '100px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        }
      ]
    },
    Table_3: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'DocumentNumber',
          selector: 'documentnumber',
          style: { width: '100px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdto',
          style: { width: '100px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { width: '100px' }
        },
        {
          name: 'CostAllocationMethod',
          selector: 'costallocationmethod',
          style: { width: '100px' }
        },
        {
          name: 'LOB',
          selector: 'lob',
          style: { width: '100px' }
        },
        {
          name: 'CostAllocationParameterValue',
          selector: 'costallocationparametervalue',
          style: { width: '100px' }
        },
        {
          name: 'CostAllocatedLclCurr',
          selector: 'amountinlocalcurrency',
          style: { width: '100px' }
        }
      ]
    },
    Table__1: {
      data: null,
      FULL_data: null,
      selected_ID: [],
      columns: [
        {
          name: 'DocumentNumber',
          selector: 'documentnumber'
        },
        {
          name: 'DocumentType',
          selector: 'documenttype'
        },
        {
          name: 'VenderName',
          selector: 'sendername'
        },
        {
          name: 'Provision',
          selector: 'totalbasevalue'
        },
        // {
        //     name: 'ThisPrdBaseValue',
        //     selector:'thisprdbasevalue',
        // },
        {
          name: 'BillBooked',
          selector: 'billvalue'
        },
        {
          name: 'ProvisionReversedAJ',
          selector: 'processedaj'
        },
        {
          name: 'ReversalToPostAJ',
          selector: 'topostaj'
        },
        {
          name: 'ProvisionReversedCA',
          selector: 'processedca'
        },
        {
          name: 'ReversalToPostCA',
          selector: 'topostca'
        },
        {
          name: 'AJDiffInd',
          selector: 'sumofpostjournal'
        },
        {
          name: 'SumOfAllocationValue',
          selector: 'sumofallocationvalue'
        },
        {
          name: 'Month',
          selector: 'month'
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom'
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto'
        }
      ]
    },
    Table__2: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'DocumentNumber',
          selector: 'documentnumber',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountDate',
          selector: 'accountingdate',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountClass',
          selector: 'accountclass',
          style: { minWidth: '100px' }
        },
        {
          name: 'MISGrouping',
          selector: 'misgrouping',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountCode',
          selector: 'accountcode',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountType',
          selector: 'accounttype',
          style: { minWidth: '100px' }
        },
        {
          name: 'AmtInLclCurr',
          selector: 'amountinlocalcurrency',
          style: { minWidth: '100px' }
        },
        {
          name: 'LedgerName',
          selector: 'ledgername',
          style: { minWidth: '100px' }
        },
        {
          name: 'AccountGroup',
          selector: 'accountgroup',
          style: { minWidth: '100px' }
        },
        {
          name: 'ItemType',
          selector: 'itemtype',
          style: { minWidth: '100px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdfrom',
          style: { minWidth: '100px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { minWidth: '100px' }
        }
      ]
    },
    Table__3: {
      data: null,
      FULL_data: null,
      columns: [
        {
          name: 'DocumentNumber',
          selector: 'documentnumber',
          style: { width: '100px' }
        },
        {
          name: 'ForPrdFrom',
          selector: 'forprdto',
          style: { width: '100px' }
        },
        {
          name: 'ForPrdTo',
          selector: 'forprdto',
          style: { width: '100px' }
        },
        {
          name: 'CostAllocationMethod',
          selector: 'costallocationmethod',
          style: { width: '100px' }
        },
        {
          name: 'LOB',
          selector: 'lob',
          style: { width: '100px' }
        },
        {
          name: 'CostAllocationParameterValue',
          selector: 'costallocationparametervalue',
          style: { width: '100px' }
        },
        {
          name: 'CostAllocatedLclCurr',
          selector: 'amountinlocalcurrency',
          style: { width: '100px' }
        }
      ]
    },
    fetching: false,
    StartDate: '',
    EndDate: '',
    dropdown_report: [{
      name: 'Expense Amortization Tracking',
      value: 'Table'
    }, {
      name: 'Deferred PrePayment Amortization Tracking',
      value: '_Table_'
    }
      // {
      //     name : "Cost Provision Status Tracking (PO/IP)",
      //     value : "Table_"
      // },
      // {
      //     name : "Cost Provision Status Tracking (GSE)",
      //     value : "Table__"
      // }
    ],
    OPT_: {
      Table: 'Expense Amortization Tracking',
      _Table_: 'Deferred PrePayment Amortization Tracking',
      Table_: 'Cost Provision Status Tracking (PO/IP)',
      Table__: 'Cost Provision Status Tracking (GSE)'
    },
    formData: {
      period: moment(),
      Report: '',
      ReportName: ''
    },
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().endOf('month').format('YYYY-MM-DD')
  });

  const downloadLinkRef = useRef(null);

  const handleSetState = (obj, callback) => {
    console.log(obj, callback);
    setState(prevState => {
      const newState = typeof obj === 'function' ? obj(prevState) : { ...prevState, ...obj };
      console.log(newState);

      if (callback) setTimeout(callback, 0);
      return newState;
    });
  };

  useEffect(() => {
    // Get the current year
    let currentYear = new Date().getFullYear()

    // Calculate the last three years, excluding years earlier than 2023
    let lastThreeYears = []
    for (let i = 0; i < 3; i++) {
      let year = currentYear - i
      // if (year >= 2023) {
      lastThreeYears.push(year)
      // }
    }

    console.log(lastThreeYears)

    handleSetState({ dropdown_year: lastThreeYears })

    getRequest(`api/edureka/getCompanyAssignedToUser`).then(({ res }) => {
      handleSetState((prev) => ({
        ...prev,
        Companies: (res.data || []).sort((a, b) =>
          (a.orgname || "").localeCompare(b.orgname || "")
        )
      }));
      if (res.data && res.data.length === 1) {
        handleSetState((prev) => ({ ...prev, Company: res.data[0].orgname || res.data[0] }));
      }
    }).catch((err) => console.log(err));
  }, []);

  const handleChange = (NAME, VALUE) => {
    if (NAME === 'Report') {
      handleSetState(
        {
          ...state,
          formData: {
            ...state.formData,
            [NAME]: VALUE,
            ReportName: state.OPT_[VALUE]
          }
        },
        () => console.log(state.formData)
      )
    } else {
      handleSetState(
        {
          ...state,
          formData: {
            ...state.formData,
            [NAME]: VALUE
          }
        },
        () => console.log(state.formData)
      )
    }
  }

  const handleSubmit = () => {


    handleSetState(
      {
        ...state,
        StartDate: getStandardDate(state.startDate),
        EndDate: getStandardDate(state.endDate),
        showActivate: true,
        Table1: {
          ...state.Table1,
          selected_ID: [],
          data: null,
          FULL_data: null
        },
        Table2: {
          ...state.Table2,
          data: null,
          FULL_data: null
        },
        Table3: {
          ...state.Table3,
          data: null,
          FULL_data: null
        },
        Table_1: {
          ...state.Table_1,
          selected_ID: [],
          data: null,
          FULL_data: null
        },
        Table_2: {
          ...state.Table_2,
          data: null,
          FULL_data: null
        },
        Table_3: {
          ...state.Table_3,
          data: null,
          FULL_data: null
        },
        Table__1: {
          ...state.Table__1,
          selected_ID: [],
          data: null,
          FULL_data: null
        },
        Table__2: {
          ...state.Table__2,
          data: null,
          FULL_data: null
        },
        Table__3: {
          ...state.Table__3,
          data: null,
          FULL_data: null
        }
      },
      () => {
        console.log(state.StartDate, state.EndDate)

        if (
          state.formData.Report === '_Table_' &&
          !state.EditTable.data
        ) {
          store.dispatch(showLoader())
          getRequest(
            `api/edureka/GetDeferredAmortizationTracking_pre?orgid=${state.Company}&startdate=${state.StartDate || moment(state.formData.period).startOf('month').format('YYYY-MM-DD')}&enddate=${state.EndDate || moment(state.formData.period).endOf('month').format('YYYY-MM-DD')}`
          ).then(res => {
            if (res.res.status === 'success') {
              let DATA = JSON.parse(res.res.data)

              console.log(DATA)

              handleSetState({
                ...state,
                EditTable: {
                  ...state.EditTable,
                  data: DATA
                }
              })
            }
          }).finally(() => store.dispatch(hideLoader()))
        } else if (
          state.formData.Report === '_Table_' &&
          state.EditTable.data
        ) {
          store.dispatch(showLoader())
          postRequest(
            `api/edureka/GetDeferredAmortizationTracking?orgid=${state.Company}&startdate=${state.StartDate || moment(state.formData.period).startOf('month').format('YYYY-MM-DD')}&enddate=${state.EndDate || moment(state.formData.period).endOf('month').format('YYYY-MM-DD')}`,
            { PrePaidReport: state.EditTable.data }
          ).then(res => {
            if (res.res.status === 'success') {
              console.log(res.res.data)

              let RESP = JSON.parse(res.res.data.Payload)

              console.log(RESP)

              handleSetState(prevState => {
                let updates = {
                  EditTable: {
                    ...prevState.EditTable,
                    data: null
                  }
                };

                if (RESP.ExpenseAmortizationSummary) {
                  updates._Table_1 = {
                    ...prevState._Table_1,
                    FULL_data: selectableCheck(RESP.ExpenseAmortizationSummary)
                  };
                }

                if (RESP.AmortizePrePaidAccountingJournal) {
                  updates._Table_2 = {
                    ...prevState._Table_2,
                    FULL_data: RESP.AmortizePrePaidAccountingJournal
                  };
                }

                if (RESP.PrePaidCostAllocation) {
                  updates._Table_3 = {
                    ...prevState._Table_3,
                    FULL_data: RESP.PrePaidCostAllocation
                  };
                }

                return { ...prevState, ...updates };
              });
            }
          }).finally(() => store.dispatch(hideLoader()))
        } else if (state.formData.Report === 'Table') {
          store.dispatch(showLoader())
          getRequest(
            `api/edureka/getExpenseAmortizationTracking?orgid=${state.formData.company.orgid}&startdate=${state.StartDate || moment(state.formData.period).startOf('month').format('YYYY-MM-DD')}&enddate=${state.EndDate || moment(state.formData.period).endOf('month').format('YYYY-MM-DD')}`
          ).then(res => {
            if (res.res.status === 'success') {
              console.log(res.res.data)

              let RESP = JSON.parse(res.res.data)

              console.log(RESP, {
                ...state,
                Table1: {
                  ...state.Table1,
                  FULL_data: selectableCheck(
                    RESP.ExpenseAmortizationSummary
                  )
                }
              }, {
                ...state,
                Table2: {
                  ...state.Table2,
                  FULL_data: RESP.AmortizePrePaidAccountingJournal
                }
              }, {
                ...state,
                Table3: {
                  ...state.Table3,
                  FULL_data: RESP.PrePaidCostAllocation
                }
              }, {
                ...state,
                Table4: {
                  ...state.Table4,
                  FULL_data: RESP.PrePaidCostAllocation
                }
              })

              handleSetState(prevState => {
                let updates = {};

                if (RESP.ExpenseAmortizationSummary) {
                  updates.Table1 = {
                    ...prevState.Table1,
                    FULL_data: selectableCheck(RESP.ExpenseAmortizationSummary)
                  };
                }

                if (RESP.AmortizePrePaidAccountingJournal) {
                  updates.Table2 = {
                    ...prevState.Table2,
                    FULL_data: RESP.AmortizePrePaidAccountingJournal
                  };
                }

                if (RESP.PrePaidCostAllocation) {
                  updates.Table3 = {
                    ...prevState.Table3,
                    FULL_data: RESP.PrePaidCostAllocation
                  };
                }
                console.log(updates, 'updates')

                return { ...prevState, ...updates };
              });
            }
          }).finally(() => store.dispatch(hideLoader()))
        } else if (state.formData.Report === 'Table_') {
          store.dispatch(showLoader())
          getRequest(
            `api/edureka/getCostProvisionStatusTracking?startdate=${state.StartDate || moment(state.formData.period).startOf('month').format('YYYY-MM-DD')}&enddate=${state.EndDate || moment(state.formData.period).endOf('month').format('YYYY-MM-DD')}`
          ).then(res => {
            if (res.res.status === 'success') {
              console.log(res.res.data)

              let RESP = JSON.parse(res.res.data)

              console.log(RESP)

              handleSetState(prevState => {
                let updates = {};

                if (RESP.CostProvisionSummary) {
                  updates.Table_1 = {
                    ...prevState.Table_1,
                    FULL_data: selectableCheck(RESP.CostProvisionSummary)
                  };
                }

                if (RESP.CostProvisionJournal) {
                  updates.Table_2 = {
                    ...prevState.Table_2,
                    FULL_data: RESP.CostProvisionJournal
                  };
                }

                if (RESP.CPCostAllocation) {
                  updates.Table_3 = {
                    ...prevState.Table_3,
                    FULL_data: RESP.CPCostAllocation
                  };
                }

                return { ...prevState, ...updates };
              });
            }
          }).finally(() => store.dispatch(hideLoader()))
        } else {
          store.dispatch(showLoader())
          getRequest(
            `api/edureka/getCostProvisionReversal?startdate=${state.StartDate || moment(state.formData.period).startOf('month').format('YYYY-MM-DD')}&enddate=${state.EndDate || moment(state.formData.period).endOf('month').format('YYYY-MM-DD')}`
          ).then(res => {
            if (res.res.status === 'success') {
              console.log(res.res.data)

              let RESP = JSON.parse(res.res.data.Payload)
              console.log(RESP)

              handleSetState(prevState => {
                let updates = {};

                if (RESP.CostProvisionSummary) {
                  updates.Table__1 = {
                    ...prevState.Table__1,
                    FULL_data: selectableCheck(RESP.CostProvisionSummary)
                  };
                }

                if (RESP.CostProvisionReversalJournal) {
                  updates.Table__2 = {
                    ...prevState.Table__2,
                    FULL_data: RESP.CostProvisionReversalJournal
                  };
                }

                if (RESP.CPBGSERCostAllocation) {
                  updates.Table__3 = {
                    ...prevState.Table__3,
                    FULL_data: RESP.CPBGSERCostAllocation
                  };
                }

                return { ...prevState, ...updates };
              });
            }
          }).finally(() => store.dispatch(hideLoader()))
        }
      }
    )
  }

  const selectableCheck = array => {

    array.forEach(each => {
      const isAllocationComplete = (each.sumofallocationvalue === each.topostca ||
        Number(each.sumofallocationvalue) === Number(each.topostca));
      const isJournalNotPosted = (each.sumofpostjournal === '0' ||
        each.sumofpostjournal === '0.0' ||
        each.sumofpostjournal === 0);
      const hasAJToPost = each.topostaj !== '0' &&
        each.topostaj !== '0.0' &&
        each.topostaj !== 0 &&
        each.topostaj !== '' &&
        each.topostaj !== 'nan';
      const isValidCA = each.topostca !== 'nan';

      if (isAllocationComplete && isJournalNotPosted && hasAJToPost && isValidCA) {
        each.selectable = true
      } else {
        each.selectable = false
      }
      console.log(each, "each");

    })

    console.log(array, "array")

    return _.sortBy(array, 'documentref')
  }

  const onCheckbox = ID => {
    let Table = state.formData.Report

    let selected_ID = state[Table + '1'].selected_ID

    if (selected_ID.includes(ID)) {
      selected_ID = selected_ID.filter(each => each !== ID)
    } else selected_ID.push(ID)

    applyFilter(Table, selected_ID)
  }

  const applyFilter = (Table, selected_ID) => {
    let data2 = state[Table + '2'].FULL_data.filter(each =>
      selected_ID.includes(each.documentnumber)
    )

    let data3 = state[Table + '3'].FULL_data.filter(each =>
      selected_ID.includes(each.documentnumber)
    )
    console.log(data2, data3, selected_ID);


    setState({
      ...state,
      [Table + '1']: {
        ...state[Table + '1'],
        selected_ID
      },
      [Table + '2']: {
        ...state[Table + '2'],
        data: data2
      },
      [Table + '3']: {
        ...state[Table + '3'],
        data: data3
      }
    })
  }

  const selectALL = all => {
    let tabl = state.formData.Report

    let Table = state[tabl + '1'].FULL_data

    let selected_ID = []

    if (all) {
      Table.forEach(each => {
        if (each.selectable) selected_ID.push(each.documentnumber)
      })
    }

    applyFilter(tabl, selected_ID)
  }

  const handleDownload = () => {
    handleSetState(
      {
        ...state
      },
      () => {
        downloadLinkRef.current.link.click()
      }
    )
  }

  const onSave = () => {
    console.log('onSave')

    handleSetState(
      {
        showActivate: false
      },
      () => {
        let Report = state.formData.Report

        let selected_ID = state[Report + '1'].selected_ID

        let arry = []

        selected_ID.forEach(each => {
          let obj = {}

          obj.ID = each

          obj.data2 = state[Report + '2'].FULL_data.filter(
            one => each === one.documentnumber
          )
          obj.data3 = state[Report + '3'].FULL_data.filter(
            one => each === one.documentnumber
          )

          arry.push(obj)
        })

        console.log(arry)

        let formData = state.formData

        postRequest(
          `api/edureka/periodEndProcess_Save?orgid=${state.Company}&fileName=${formData.ReportName}_${formData.period}`,
          arry
        ).then(res => {
          console.log(res)

          setTimeout(() => {
            GetLogs()

            // window.location.reload()
          }, 4000)
        })

        // Call the function to start making the API calls in sequence

        // handleSetState({Logs_Array : arry})

        // makeApiCallsSequentially(arry);
      }
    )
  }

  const GetLogs = () => {
    let formData = state.formData

    getRequest(
      `api/edureka/periodEndProcess_GetLog?orgid=${state.Company}&fileName=${formData.ReportName}_${formData.period}`
    ).then(res => {
      if (res.res.status === 'success') {
        let DATA = JSON.parse(res.res.data)

        // const logSortOrder = (log) => {
        //     if (log === 'Started') return 0;
        //     if (log === 'Success') return 1;
        //     return 2; // Assume 'Failed' as last priority
        // };

        // const sortProcessCd = (log) => {
        //     if (log === 'AD') return 0;
        //     if (log === 'CA') return 1;
        // };

        // DATA = _.orderBy(DATA, ['ID', (item) => sortProcessCd(item.ProcessCode), (item) => logSortOrder(item.Log), 'Time'], ['asc', 'desc', 'desc', 'desc']);

        DATA = _.orderBy(DATA, ['ID', 'SortKey'], ['asc', 'desc'])

        console.log(DATA)

        handleSetState({ Logs_Array: DATA })
      }
    })
  }

  const makeApiCallsSequentially = async ARRAY => {
    const itemsToProcess = ARRAY

    for (const item of itemsToProcess) {
      // Make the API call using fetch or any other method
      const response = await postRequest(
        `api/edureka/periodEndProcess_Save_`,
        item
      )

      // Process the response as needed
      const RES = await response

      let status = '...';
      if (RES.res.status === 'success') status = 'Success'; else status = 'Failed';
      handleSetState(prevState => {
        let Logs_Array = prevState.Logs_Array;
        Logs_Array.forEach(each => {
          if (each.ID === item.ID) each.status = status;
          console.log(each);
        });
        return {
          ...prevState,
          Logs_Array
        };
      }, () => {
        console.log(state.Logs_Array);
      });
    }
  }

  const showErr = obj => {
    console.log(obj)

    if (obj.topostca === 'nan') {
      TopErrAlert(`This Month CA ToPost is "nan"`)
    }
  }

  const TopErrAlert = msg => {
    handleSetState({
      alert: <Animated animationIn='fadeInDown' animationOut='fadeInUp' isVisible={true}>
        {' '}
        <div className='alert alert-danger'>
          <strong>{msg}</strong>
        </div>{' '}
      </Animated>
    });
    setTimeout(() => {
      handleSetState({ alert: null })
    }, 3000)
  }

  const onEditTableChange = (row, e) => {
    let val = e.target.value;
    let name = e.target.name;
    let DATA = state.EditTable.data;
    console.log(val);
    if (val === '') { } else if (name === 'BaseValue') {
      val = Number(val);
    }

    if (val <= DATA[row]['amountinlocalcurrency']) {
      DATA[row][name] = val

      handleSetState(
        {
          ...state,
          EditTable: {
            ...state.EditTable,
            data: DATA
          }
        },
        () => {
          console.log(state.EditTable.data)
        }
      )
    } else {
      TopErrAlert(
        `BaseValue should be less than or equal to "BalanceToBeAmortized"`
      )
    }
  };
  const TABLE = state.formData.Report;
  return <>
    {state.Logs_Array && <DialougeBox message={<TableContainer>
      <Box align='right'>
        <Button color='success' variant='contained' onClick={GetLogs}>
          <HiOutlineRefresh /> Refresh
        </Button>
      </Box>
      <Table striped bordered hover>
        <TableHead>
          <TableRow>
            {(state.Logs_Array && state.Logs_Array.length > 0 ? Object.keys(state.Logs_Array[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
              textAlign: 'left'
            }}><b>{key}</b></TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {(state.Logs_Array || []).map((row, rowIndex) => <TableRow key={rowIndex}>
            {Object.entries(row || {}).map(([key, val], valIndex) => {
              let displayVal = val;
              if (typeof val === 'number' && !Number.isInteger(val)) {
                displayVal = val.toFixed(2);
              } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                displayVal = parseFloat(val).toFixed(2);
              } else if (typeof val === 'boolean') {
                displayVal = val ? 'Yes' : 'No';
              } else if (val === null || val === undefined) {
                displayVal = '';
              } else if (typeof val === 'object') {
                displayVal = JSON.stringify(val);
              }
              return <TableCell key={valIndex} sx={{
                textAlign: 'left'
              }}>
                {String(displayVal)}
              </TableCell>;
            })}
          </TableRow>)}
        </TableBody>
      </Table>
    </TableContainer>} onClose={() => handleSetState({
      Logs_Array: null
    })} />}

    {state.alert}

    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant='h6'>Search</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container gap={2} spacing={3}>
          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete size="small" fullWidth value={state.formData.company || null} options={state.Companies || []} getOptionLabel={option => option?.orgname || ""} isOptionEqualToValue={(option, value) => option?.orgid === value?.orgid} onChange={(event, newValue) => handleChange("company", newValue)} renderInput={params => <TextField {...params} label="Company Name" variant="outlined" />} />
          </Grid>

          <Grid item xs={1} sm={2} md={2}>
            <Autocomplete options={state.dropdown_report} getOptionLabel={option => option.name} isOptionEqualToValue={(option, value) => option.value === value} value={state.dropdown_report.find(opt => opt.value === state.formData.Report) || null} onChange={(e, newValue) => handleChange('Report', newValue?.value || '')} renderInput={params => <TextField {...params} label='Report' variant='outlined' size='small' />} />
          </Grid>

          <Grid item xs={1} sm={2} md={2}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker label="Period" views={['year', 'month']} value={state.formData.period ? moment(state.formData.period) : null} minDate={moment('1900-01-01')} maxDate={moment()} onChange={newValue => {
                if (newValue) {
                  const formatted = moment(newValue).startOf('month').format('YYYY-MM-DD');
                  handleChange('period', formatted);
                }
              }} renderInput={params => <TextField variant='outlined' fullWidth size='small' {...params} />} />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={3}>
            <Button size='small' variant='contained' color='warning' disabled={!state.formData.period || !state.formData.Report} onClick={handleSubmit}>
              Get
            </Button>
            &nbsp;&nbsp;
            <Button size='small' variant='contained' color='success' disabled={!state.formData.period || !state.formData.Report} onClick={GetLogs}>
              GetLogs
            </Button>
          </Grid>
        </Grid>{' '}
      </AccordionDetails>
    </Accordion>

    {state.EditTable.data && <>
      <Typography variant='h5' component='h5'>
        PrePaidReport
      </Typography>

      <TableContainer>
        <Table className='Table' id='Table-css'>
          <TableHead>
            <TableRow>
              {(state.EditTable.data && state.EditTable.data.length > 0 ? Object.keys(state.EditTable.data[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {(state.EditTable.data || []).map((row, rowIndex) => <TableRow key={rowIndex}>
              {Object.entries(row || {}).map(([key, val], valIndex) => {
                let displayVal = val;
                if (typeof val === 'number' && !Number.isInteger(val)) {
                  displayVal = val.toFixed(2);
                } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                  displayVal = parseFloat(val).toFixed(2);
                } else if (typeof val === 'boolean') {
                  displayVal = val ? 'Yes' : 'No';
                } else if (val === null || val === undefined) {
                  displayVal = '';
                } else if (typeof val === 'object') {
                  displayVal = JSON.stringify(val);
                }
                return <TableCell key={valIndex} sx={{
                  textAlign: 'left'
                }}>
                  {String(displayVal)}
                </TableCell>;
              })}
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>

      <Box align='center'>
        <Button variant='contained' color='warning' onClick={handleSubmit}>
          Get
        </Button>
      </Box>
    </>}

    {(state.Table1.FULL_data || state._Table_1.FULL_data) && <>
      <Typography variant='h5' component='h5'>
        {state.OPT_[TABLE]} Report
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={1} align='left'>
          <Button variant='contained' color='primary' sx={{
            whiteSpace: 'nowrap'
          }} onClick={() => selectALL(true)}>
            Select All
          </Button>
        </Grid>
        <Grid item xs={1} align='left'>
          <Button sx={{
            whiteSpace: 'nowrap'
          }} variant='contained' color='secondary' onClick={() => selectALL()}>
            Select None
          </Button>
        </Grid>
        <Grid item xs={1} align='right'>
          <Button variant='contained' color='primary' onClick={handleDownload}>
            {' '}
            <GetAppIcon /> CSV
          </Button>
          <CSVLink data={state[TABLE + '1'].FULL_data} filename={`${state.OPT_[TABLE]}.csv`} ref={downloadLinkRef} target='_blank'></CSVLink>
        </Grid>
      </Grid>

      <TableContainer>
        <Table className='Table' id='Table-css'>
          <TableHead>
            <TableRow>
              {(state[TABLE + '1'].FULL_data && state[TABLE + '1'].FULL_data.length > 0 ? Object.keys(state[TABLE + '1'].FULL_data[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {(state[TABLE + '1'].FULL_data || []).map((row, rowIndex) => <TableRow key={rowIndex}>
              {Object.entries(row || {}).map(([key, val], valIndex) => {
                let displayVal = val;
                if (typeof val === 'number' && !Number.isInteger(val)) {
                  displayVal = val.toFixed(2);
                } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                  displayVal = parseFloat(val).toFixed(2);
                } else if (typeof val === 'boolean') {
                  displayVal = val ? 'Yes' : 'No';
                } else if (val === null || val === undefined) {
                  displayVal = '';
                } else if (typeof val === 'object') {
                  displayVal = JSON.stringify(val);
                }
                return <TableCell key={valIndex} sx={{
                  textAlign: 'left'
                }}>
                  {String(displayVal)}
                </TableCell>;
              })}
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>

      <Box align='center'>
        <Button variant='contained' color='success' disabled={!state[TABLE + '1'].selected_ID.length || !state.showActivate} onClick={onSave}>
          Activate
        </Button>
      </Box>
    </>}

    <br />

    {(state.Table2.data || state._Table_2.data) && <TableWithDownload title={'Amortization Accounting Journal'} columns={state[TABLE + '2'].columns} data={state[TABLE + '2'].data} download={true} loading={false} downloadFileName={'AmortizationAccountingJournal'} />}

    <br />

    {(state.Table3.data || state._Table_3.data) && <TableWithDownload title={'Cost Allocation'} columns={state[TABLE + '3'].columns} data={state[TABLE + '3'].data} download={true} loading={false} downloadFileName={'CostAllocation'} />}

    {/* screen 2 */}

    {state.Table_1.FULL_data && <>
      <Typography variant='h5' component='h5'>
        Cost Provision Summary (PO/IP)
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={2} align='left'>
          <Button variant='contained' color='primary' onClick={() => selectALL(true)}>
            Select All
          </Button>
          <Button variant='contained' color='secondary' onClick={() => selectALL()}>
            Select None
          </Button>
        </Grid>
        <Grid item xs={2} align='right'>
          <Button variant='contained' color='primary' onClick={handleDownload}>
            {' '}
            <GetAppIcon /> CSV
          </Button>
          <CSVLink data={state.Table_1.FULL_data} filename='CostProvisionSummary.csv' ref={downloadLinkRef} target='_blank'></CSVLink>
        </Grid>
      </Grid>

      <TableContainer>
        <Table className='Table' id='Table-css'>
          <TableHead>
            <TableRow>
              {(state.Table_1.FULL_data && state.Table_1.FULL_data.length > 0 ? Object.keys(state.Table_1.FULL_data[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {(state.Table_1.FULL_data || []).map((row, rowIndex) => <TableRow key={rowIndex}>
              {Object.entries(row || {}).map(([key, val], valIndex) => {
                let displayVal = val;
                if (typeof val === 'number' && !Number.isInteger(val)) {
                  displayVal = val.toFixed(2);
                } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                  displayVal = parseFloat(val).toFixed(2);
                } else if (typeof val === 'boolean') {
                  displayVal = val ? 'Yes' : 'No';
                } else if (val === null || val === undefined) {
                  displayVal = '';
                } else if (typeof val === 'object') {
                  displayVal = JSON.stringify(val);
                }
                return <TableCell key={valIndex} sx={{
                  textAlign: 'left'
                }}>
                  {String(displayVal)}
                </TableCell>;
              })}
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>

      <Box align='center'>
        <Button variant='contained' color='success' disabled={!state.Table_1.selected_ID.length || !state.showActivate} onClick={onSave}>
          Activate
        </Button>
      </Box>
    </>}

    <br />

    {state.Table_2.data && <TableWithDownload title={'Cost Provision Accounting Journal (PO/IP)'} columns={state.Table_2.columns} data={state.Table_2.data} download={true} loading={false} downloadFileName={'CostProvisionAccountingJournal(PO/IP)'} />}

    <br />

    {state.Table_3.data && <TableWithDownload title={'Cost Allocation (PO/IP)'} columns={state.Table_3.columns} data={state.Table_3.data} download={true} loading={false} downloadFileName={'CostAllocation(PO/IP)'} />}

    {/* screen 3 */}

    {state.Table__1.FULL_data && <>
      <Typography variant='h5' component='h5'>
        Cost Provision Summary (GSE)
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={2} align='left'>
          <Button variant='contained' color='primary' onClick={() => selectALL(true)}>
            Select All
          </Button>
          <Button variant='contained' color='secondary' onClick={() => selectALL()}>
            Select None
          </Button>
        </Grid>
        <Grid item xs={2} align='right'>
          <Button variant='contained' color='primary' onClick={handleDownload}>
            {' '}
            <GetAppIcon /> CSV
          </Button>
          <CSVLink data={state.Table__1.FULL_data} filename='CostProvisionSummary(GSE).csv' ref={downloadLinkRef} target='_blank'></CSVLink>
        </Grid>
      </Grid>

      <TableContainer>
        <Table className='Table' id='Table-css'>
          <TableHead>
            <TableRow>
              {(state.Table__1.FULL_data && state.Table__1.FULL_data.length > 0 ? Object.keys(state.Table__1.FULL_data[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                textAlign: 'left'
              }}><b>{key}</b></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {(state.Table__1.FULL_data || []).map((row, rowIndex) => <TableRow key={rowIndex}>
              {Object.entries(row || {}).map(([key, val], valIndex) => {
                let displayVal = val;
                if (typeof val === 'number' && !Number.isInteger(val)) {
                  displayVal = val.toFixed(2);
                } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                  displayVal = parseFloat(val).toFixed(2);
                } else if (typeof val === 'boolean') {
                  displayVal = val ? 'Yes' : 'No';
                } else if (val === null || val === undefined) {
                  displayVal = '';
                } else if (typeof val === 'object') {
                  displayVal = JSON.stringify(val);
                }
                return <TableCell key={valIndex} sx={{
                  textAlign: 'left'
                }}>
                  {String(displayVal)}
                </TableCell>;
              })}
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>

      <Box align='center'>
        <Button variant='contained' color='success' disabled={!state.Table__1.selected_ID.length || !state.showActivate} onClick={onSave}>
          Activate
        </Button>
      </Box>
    </>}

    <br />

    {state.Table__2.data && <TableWithDownload title={'Cost Provision Accounting Journal (GSE)'} columns={state.Table__2.columns} data={state.Table__2.data} download={true} loading={false} downloadFileName={'CostProvisionAccountingJournal(GSE)'} />}

    <br />

    {state.Table__3.data && <TableWithDownload title={'Cost Allocation (GSE)'} columns={state.Table__3.columns} data={state.Table__3.data} download={true} loading={false} downloadFileName={'CostAllocation(GSE)'} />}
  </>;
};
export default FunctionalJournal;
